<template>
  <div class="w-content-standard select-wrapper pt-4 pb-2 mx-auto">
    <FormKit
        class=""
        type="select"
        label="Location"
        name="location"
        v-model="appStore.location"
        :options="appStore.locations"
    />
  </div>
</template>

<script>
import { onMounted } from "vue";
import { useAppStore } from '@/store/app';
import axios from "axios";

export default {
  name: "LocationChooser.vue",
  setup() {
    const appStore = useAppStore();

    const fetchLocationPermissions = async () => {
      try {
        const response = await axios.get("/api/location_permissions");
        appStore.location_permissions = response.data;

        // Check if the current location is still valid among the fetched permissions
        if (appStore.location) {
          const is_valid_location = appStore.locations.some(permission => permission === appStore.location);
          if (!is_valid_location) {
            // Reset location if it's no longer valid
            // Set to the first available permission, or null if none exist
            appStore.location = appStore.locations.length > 0 ? appStore.locations[0] : null;
          }
        } else if (appStore.locations.length > 0) {
            // If no location is set, default to the first one
            appStore.location = appStore.locations[0];
        }

      } catch (error) {
        console.error("Error fetching location permissions:", error);
      }
    };

    onMounted(() => {
      // Fetch permissions on mount only
      fetchLocationPermissions();
    });
    
    return {
      appStore
    }
  }
}
</script>

<style scoped>
.select-wrapper > div {
  max-width: unset;
}
</style>